module.exports = __webpack_public_path__ + "img/business-services-icon.1c0264d6.svg";